export const generateWindowIframeId = (windowId: string) => {
  return `iframe-${windowId}`
}

export const getWindowIdFromIframeId = (iframeId: string) => {
  return iframeId.replace('iframe-', '')
}
